
export const iniPayClientDetails = {
    type: '',
    targetId: '',
    total: '',
    currency: '',
    title: ''
  };